// Install on the homepage with the commerce custom pixel. Product routes already
// emit Shopify's product_viewed event; the product landing homepage does not.
(() => {
  if (window.location.pathname !== '/' || window.__renlyProductViewPublished) return;
  let sent = false;
  function publish() {
    const privacy = window.Shopify?.customerPrivacy;
    if (sent || privacy?.marketingAllowed() !== true ||
        privacy?.analyticsProcessingAllowed() !== true || privacy?.saleOfDataAllowed() !== true) return;
    const root = document.querySelector('[data-renly-root]');
    const offer = root?.querySelector('[data-offer].is-selected');
    if (!root || !offer || !window.Shopify?.analytics?.publish) return;
    sent = true;
    window.__renlyProductViewPublished = true;
    window.Shopify.analytics.publish('renly_product_viewed', {
      productVariant: {
        id: offer.dataset.variantId,
        title: offer.dataset.variantTitle,
        product: { id: root.dataset.productId, title: root.dataset.productTitle },
        price: { amount: Number(offer.dataset.price) / 100, currencyCode: root.dataset.currency },
      },
    });
  }
  document.addEventListener('visitorConsentCollected', publish);
  if (window.Shopify?.customerPrivacy) publish();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => {
    if (!error) publish();
  });
})();
